import { Injectable } from '@angular/core';
import { LocalStorage } from '../storage/local.storage';
import { UserState } from './user-state';
import { AuthResponse } from '@adminPortal/_common/_interfaces/IAuthResponse';

@Injectable({
  providedIn: 'root',
})
export class UserService implements UserState {
  constructor(private storage: LocalStorage) {}

  public getAuthEmail(): string | null {
    return this.storage.get('email');
  }

  public setAuthEmail(email: string): void {
    this.storage.set('email', email);
  }

  public clearAuthEmail(): void {
    this.storage.delete('email');
  }

  public getAuthToken(): string | null {
    return this.storage.get('token');
  }

  public getRefreshToken(): string | null {
    return this.storage.get('refreshToken');
  }

  public getTokenExpireAt(): number | null {
    const value = this.storage.get('tokenExpireAt');
    return value ? Number(value) : null;
  }

  public getRefreshTokenExpireAt(): number | null {
    const value = this.storage.get('refreshTokenExpireAt');
    return value ? Number(value) : null;
  }

  public setAuthTokens(response: AuthResponse): void {
    this.storage.set('token', response.token);
    this.storage.set('tokenExpireAt', response.tokenExpireAt.toString());
    this.storage.set('refreshToken', response.refreshToken);
    this.storage.set('refreshTokenExpireAt', response.refreshTokenExpireAt.toString());
  }

  public setAuthToken(token: string): void {
    this.storage.set('token', token);
  }

  public clearAuthTokens(): void {
    this.storage.delete('token');
    this.storage.delete('tokenExpireAt');
    this.storage.delete('refreshToken');
    this.storage.delete('refreshTokenExpireAt');
  }

  public clearAuthToken(): void {
    this.clearAuthTokens();
  }

  public hasAuthToken(): boolean {
    return this.storage.has('token');
  }
}